import { ListTags, ListTagsVariables } from './__generated__/ListTags'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListTags($input: ListNotificationTagInputV2!) {
    listNotificationTags: listNotificationTagsV2(input: $input) {
      nextCursor
      notificationTags {
        id
        title
        tagGroup
      }
    }
  }
`

export const useListTags = (variables: ListTagsVariables) =>
  useQuery<ListTags, ListTagsVariables>(QUERY, {
    variables
  })
